import amaLog from '../helpers/log';
import { timeFor } from '../helpers/time';
import { hasTcfConsent } from './tcfv2';
import getTcfConsent, { Event } from './tcfv2';

export type ConsentState = {
  hasConsent: boolean | undefined;
  hasActiveInteraction: boolean;
  eventStatus?: Event;
};

export const getConsentState = async (): Promise<ConsentState> => {
  try {
    amaLog('Get tcf consent ...');

    const { tcData, hasActiveInteraction, eventStatus } = await getTcfConsent();

    amaLog(`Got tcf data consent ${timeFor("getTcfConsent")} `, tcData);

    const hasConsent = hasTcfConsent(tcData);

    amaLog(`hasConsent: ${hasConsent}; hasActiveInteraction: ${hasActiveInteraction}; eventStatus: ${eventStatus}`);

    return { hasConsent, hasActiveInteraction, eventStatus };
  } catch (e) {
    console.error('Unable to retrieve tcf consent');
    return { hasConsent: undefined, hasActiveInteraction: false };
  }
};

const getConsent = async (): Promise<boolean | undefined> => {

  const { hasConsent } = await getConsentState();
  return hasConsent;
};

export default getConsent;
